export const SituacionDeEntregaCredencial = {
    1: 'PENDIENTE DE DESPACHO',
    2: 'DESPACHADA',
    3: 'EN GESTIÓN',
    4: 'GESTIÓN VENCIDA',
    5: 'ENTREGADA',
    6: 'NO ENTREGADA',
}

